import {PageManager} from 'genesis-packages/core';
import './FAQS.scss';

export default class FAQS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

};
